import { useEffect, useRef, useState } from "react";
import { BsQuestionCircle } from "react-icons/bs";
import { useNavigate, useParams } from "react-router-dom";
import WebService from "../../utility/WebService";

const HelpButton = (props: any) => {
  const history = useNavigate();
  // const menu_id = localStorage.getItem("menu_id");
  // const [data, setData] = useState("");
  const url = window.location.pathname;
  // useEffect(() => {
    // if(url){
    //   getHelpDetails();
    // }
    // },[])

  // const getHelpDetails = () => {
  //   WebService.postAPI({
  //     action: `/v2/ModuleInformationMaster/GetHelpDetails?url=${url}`,
  //     body: null
  //   })
  //     .then((res: any) => {
  //       const data = res.data
  //       ? res.data
  //       .replace(
  //         /<ul>/g,
  //         '<ul style="list-style-type: disc; margin-left: 20px;">'
  //       )
  //       .replace(
  //         /<ol>/g,
  //         '<ol style="list-style-type: decimal; margin-left: 20px;">'
  //       )
  //       : "";
  //       setData(data);
  //     })
  //     .catch(() => {
  //     });
  // }

  //Open in new tab with header footer and the same url
  const openHelpWindow = () =>{
    localStorage.setItem("url", url)
    window.open("/help-window", "_blank");
  }

  //Open in new tab without any header and url is same as the page
  // const openHelpWindow = () => {
  //   const newWindow = window.open("about:blank", "_blank");
  //   if (newWindow) {
  //     newWindow.document.write(`
  //       <html>
  //         <head>
  //           <title>Help</title>
  //           <style>
  //             body { font-family: Arial, sans-serif; padding: 20px; }
  //             h1 { color: #0073e6; }
  //             p { font-size: 16px; }
  //           </style>
  //         </head>
  //         <body>
  //       <div style="font-size: 24px; font-weight: bold; cursor: pointer;">Help</div>
  //       <p>${data}</p>
  //         </body>
  //       </html>
  //     `);
  //     newWindow.document.close();
  //   }
  // };

  //Open in new tab without any header and url
  // const openHelpWindow = () => {
  //   const newWindow = window.open("about:blank", "_blank");
  //   if (newWindow) {
  //     let iframe = newWindow.document.createElement('iframe');
  //     setTimeout(() => {
  //       iframe.style.width = "100%";
  //       iframe.style.height = "100%";
  //       iframe.style.border = "none";
        
  //       newWindow.document.body.appendChild(iframe);
  //       newWindow.document.title = "Help";
  //       const iframeDoc = iframe.contentWindow;

  //       iframeDoc?.document.open();
  //       iframeDoc?.document.write(`
  //         <html>
  //           <head>
  //             <title>Help</title>
  //           </head>
  //           <body>
  //             <div style="font-size: 24px; font-weight: bold; cursor: pointer;">Help</div>
  //             <p>${data}</p>
  //           </body>
  //         </html>
  //       `);
  //       iframeDoc?.document.close();
  //     }, 100); 
  //   }
  // };

  return (
    <>
      <button
        type="button"
        className={props.className || "btn bg-white px-3 py-1 rounded-md hover:shadow-xl  shadow-sm mr-3"}
        title="Help"
        onClick={() => {
          openHelpWindow()
        }
        }
      >
        <BsQuestionCircle size={props.iconSize || 20} className="inline mr-1" /> Help
      </button>
      {/* <button
            type="button"
            className="btn bg-white px-3 py-1 rounded-md hover:shadow-xl  shadow-sm mr-3"
            title="Help"
            onClick={() => setOpen(true)}
          >
            <BsQuestionCircle size={20} className="inline mr-1" /> Help
          </button> 
      */}
    </>
  );
};

export default HelpButton;
